import axios from '@src/public/utils/request';

// 加入追踪
export const followTimeline = id => {
    return axios.post('/timeline/front/api/follows', {
        timelineId: id,
    });
};

// 取消追踪
export const cancelFollowTimeline = id => {
    return axios.delete('/timeline/front/api/follows', {
        data: { timelineId: id },
    });
};

// 时间线接口
export const getTimelineList = ({ id, page, size = 10, party, highlights = 0, order }) => {
    return axios.get(`/timeline/front/api/timelines/${id}`, {
        params: { page, size, party, highlights, order },
    });
};

// 评论弹幕接口
export const getCommonList = ({ id, size }) => {
    return axios.get(`/timeline/front/api/timelines/${id}/bullet-comments`, {
        params: { size },
    });
};
